export default "__VITE_ASSET__Bmn5kVuO__"